export default "__VITE_ASSET__IEcExffR__"